import React , {useEffect, useState} from "react"

import { Button, Col, FormGroup, InputGroup, Label, Row } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import Flatpickr from "react-flatpickr"
import { connect } from "react-redux";
import Select from "react-select"
import makeAnimated from "react-select/animated"

// Pages Components
import Miniwidget from "./Miniwidget"
import MonthlyEarnings from "./montly-earnings";
import EmailSent from "./email-sent";
import MonthlyEarnings2 from "./montly-earnings2";
import LatestTransactions from "./latest-transactions";
import LatestOrders from "./latest-orders";
import * as url from "./../../helpers/url_helper"
import moment from "moment";
//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { array } from "prop-types";

const Dashboard = (props) => {

  document.title = "Tableau de bord: UE DIGITAL";

  const breadcrumbItems = [
    { title: "UE DIGITAL", link: "#" },
    { title: "Tableau de bord", link: "#" }
  ]

  useEffect(() => {
    props.setBreadcrumbItems('Tableau de Bord Guichet', breadcrumbItems)
    loadGlobalStat()
    loadAgences()
    lastOperations()
    lastBordereau()
    loadBordByDelay()
    loadStatByDates()
  }, [])

  const loadGlobalStat=()=> {
    fetch(url.API_LIVRAISON_BACKEND+"/demandes/stats?start="+startDate+"&end="+endDate, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.status==200) { 
        setTotal(responseJson.data.total);
        setConfirm(responseJson.data.confirm);
        setProgress(responseJson.data.progress);
        setDone(responseJson.data.done);
        setCaGlobal(responseJson.data.sum);
    } else {  }
    }) .catch((error) => {  });
  };
  
  const loadBordByDelay=()=> {
    fetch(url.BACKEND_URL+"/bordereau/count-by-delay/"+userJson.usAgence.agId, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.status==200) { 
        setSeries([{ name: 'Series A', data: [responseJson.data.pendSince2h, responseJson.data.pendSince4h, responseJson.data.pendSince6h, responseJson.data.pendSinceOther]}]);
    } else {  }
    }) .catch((error) => {  });
  };
  
  const lastOperations=()=> {
    fetch(url.API_LIVRAISON_BACKEND+"/demandes?start=2024-08-01&end="+endDate+"&size=5", {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        setLastOp(responseJson.data.items)
    } else {  }
    }) .catch((error) => {  });
  };
  
  const lastBordereau=()=> {
    fetch(url.API_LIVRAISON_BACKEND+"/clients?start=2024-08-01&end="+endDate+"&size=5", {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.status==200) { 
        setLastBord(responseJson.data.items)
    } else {  }
    }) .catch((error) => {  });
  };
  
  const loadAgences= ()=> {
    let agencesArray= [{label: "Toutes les agences", value: ''}];
    fetch(url.BACKEND_URL+"/agence?etp="+userJson.usAgence.agEtp.etpId+"&size=100", {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { console.log(userJson.usId);
        agencesArray=[
          ...agencesArray,
          ...responseJson.data.map(item=>({
          label: item.agNom,
          value: item.agId
        }))];
        setAgences(agencesArray);
    } else {  }
    }) .catch((error) => {  });
  };
  
  const loadStatByDates= ()=> {
    let axeArray= []; let valArray= [];
    fetch(url.BACKEND_URL+"/operation/stat-by-dates?user="+userJson.usId, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        axeArray=[
          ...axeArray,
          ...responseJson.data.map(item=>(item.date ))]; console.log(JSON.stringify(axeArray.reverse()));
        
        valArray=[
          ...valArray,
          ...responseJson.data.map(item=>(item.count))]; console.log(JSON.stringify(valArray.reverse()));
        setValDaylyStat(valArray);
        setAxeDaylyStat(axeArray);
    } else {  }
    }) .catch((error) => {  });
  };
  
  const userJson= JSON.parse(localStorage.getItem("user"));
  const [total, setTotal] = useState(0);
  const [confirm, setConfirm] = useState(0);
  const [progress, setProgress] = useState(0);
  const [done, setDone] = useState(0);
  const [caGlobal, setCaGlobal] = useState(0);
  const [agences, setAgences] = useState([]);
  const [dest, setDest] = useState('');
  const [selectedDest, setSelectedDest] = useState(null);
  const [lastOp, setLastOp] = useState([]);
  const [lastBord, setLastBord] = useState([]);
  const [series, setSeries]= useState([{ name: 'Series A', data: [0, 0, 0, 0]}]);
  const optionGroup = [ { options: agences } ]
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const handleStartDate= (date)=>{ setStartDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleEndDate= (date)=>{ setEndDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleDestination= (event)=>{ setSelectedDest(event); setDest(event.value); }
  const [axeDaylyStat, setAxeDaylyStat]= useState([]);
  const [valDaylyStat, setValDaylyStat]= useState([]);
  

  const reports = [
    { title: "Total", message: "Demandes reçues", iconClass: "cube-outline", color: "bg-primary", total: total, average: "+11%", badgecolor: "info" },
    { title: "Confirmées", message: "Total demandes confirmées", iconClass: "buffer", color: "bg-warning", total: confirm, average: "-29%", badgecolor: "danger" },
    { title: "En cours", message: "Total demandes en cours", iconClass: "buffer", color: "bg-info", total: progress, average: "-29%", badgecolor: "danger" },
    { title: "Terminées", message: "Total demandes livrées", iconClass: "buffer", color: "bg-success", total: done, average: "-29%", badgecolor: "danger" },
    { title: "Revenu Total", message: "Chiffre d'affaire réalisés", iconClass: "account-cash", color: "bg-secondary", total: caGlobal, average: "+89%", badgecolor: "info" },
  ]

  const columns = {
    columns: [
        ['Confirmés', confirm],
        ['En cours', progress],
        ['Terminé', done]
      ],
    type: 'donut',
  };
  return (
    <React.Fragment>
      <Row>
        <Col xl="4">
          <FormGroup className="mb-4">
            <Label>Début</Label>
            <InputGroup>
              
              <Flatpickr
                className="form-control d-block"
                placeholder="Date début"
                value={startDate}
                onChange={handleStartDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col xl="4">
          <FormGroup className="mb-4">
            <Label>Fin</Label>
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="Date Fin"
                value={endDate}
                onChange={handleEndDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col lg="3">
          <div className="mt-3">
            <Button type="button" style={{ width: "100%" }} onClick={loadGlobalStat} color="primary" data-toggle="Button" size="lg" className="mt-2 waves-effect waves-light">Rechargé</Button>
          </div>
        </Col>
      </Row>
      {/*mimi widgets */}
      <Miniwidget reports={reports} />

      <Row>
        <Col xl="3">
          {/* Monthly Earnings */}
          <MonthlyEarnings 
            columns={columns}
           />
        </Col>

        <Col xl="5">
          {/* Email sent */}
          <EmailSent info={series} />
        </Col>

        <Col xl="4">
          <MonthlyEarnings2 infos={{ axe: axeDaylyStat, value:  valDaylyStat}} />
        </Col>

      </Row>

      <Row>
        <Col xl="6">
          {/* latest transactions */}
          <LatestTransactions latest={lastOp} />
        </Col>

        <Col xl="6">
          {/* latest orders */}
          <LatestOrders latest={lastBord} />
        </Col>
      </Row>

    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Dashboard);